module.exports = __webpack_public_path__ + "static/media/Trevenant_gaussian2.46d2605c.png";